const baseURL = import.meta.env.VITE_API_BASE_URL || '';

/** Prepend the API base URL to relative media paths returned by the backend. */
export function mediaUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url)) return url;
  return `${baseURL}${url}`;
}
